import { connectedStore } from '../../store';
import getGlobalsFromHTML from './get-globals-from-html';
import getGlobalSource from './get-global-source';
import selectors from '../selectors';

const getNonLoadedGlobals = (html) => {
  const globalsFromHTML = getGlobalsFromHTML(html);

  if (globalsFromHTML.length === 0) return globalsFromHTML;

  const store = connectedStore.get();
  const state = store.getState();

  return globalsFromHTML
    .map((globalFromHTML) => {
      const source = getGlobalSource(globalFromHTML);
      return selectors.getGlobalBySource(state, source);
    })
    .reduce((nonLoadedGlobals, global) => {
      if (!global) return nonLoadedGlobals;

      if (global.html) {
        nonLoadedGlobals.push(...getNonLoadedGlobals(global.html));
      } else {
        nonLoadedGlobals.push(global);
      }

      return nonLoadedGlobals;
    }, []);
};

export default getNonLoadedGlobals;
